import React from "react";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { content } from "@glossy/theme";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { isValid } from "@tootools/number";
import Dots from "@ui-kit/loader/dots";

interface IProps {
  number: number;
  locale: Locale;
  loading?: boolean;
  className?: string;
  isPercent?: boolean;
  signed?: boolean;
}

const Root = styled.span`
  color: ${content};
`;

const Percent = styled.span`
  position: relative;
  top: -0.5em;
  font-size: 0.6em;
`;

const UiKitFormatCounter = ({
  className,
  loading,
  locale,
  number,
  isPercent,
  signed,
}: IProps) => (
  <Root className={className}>
    {loading ? (
      <Dots />
    ) : isValid(number) ? (
      <>
        {shorten(locale, number, 3, signed)}
        {isPercent && <Percent>%</Percent>}
      </>
    ) : (
      tr(locale, "CHARTS::DATA_UNKNOWN")
    )}
  </Root>
);

export default UiKitFormatCounter;
